import React from 'react';

interface ScreenViewportProps {
  children: React.ReactNode;
  title?: string;
  centered?: boolean;
  scroll?: boolean;
  contentClassName: string;
  contentStyle: React.CSSProperties;
  bottomInset?: React.CSSProperties['bottom'];
  ariaLabel: string;
}

export function ScreenViewport({
  children,
  title,
  centered = false,
  scroll = true,
  contentClassName,
  contentStyle,
  bottomInset,
  ariaLabel,
}: ScreenViewportProps) {
  return (
    <div
      className={`absolute inset-0 ${scroll ? 'overflow-y-auto' : ''} ${centered ? 'flex items-center justify-center' : 'block'}`}
      style={bottomInset ? { bottom: bottomInset } : undefined}
      id="main"
      data-scroll-root="true"
      role="main"
      tabIndex={-1}
      aria-label={ariaLabel}
      data-screen-title={title}
    >
      <div className={contentClassName} style={contentStyle}>
        {children}
      </div>
    </div>
  );
}
